module.exports = __webpack_public_path__ + "static/media/how_it_works_circle.f57cd413.png";